module.exports = __webpack_public_path__ + "img/bornutti16.5dded0b3.jpg";